export default {
  "unableToLoadOutlets": "Incapables aux prises de charge",
  "unableToLoadDiningAreas": "Incapable de charger des zones à manger",
  "unableToLoadTables": "Incapable de charger des tables",
  "unableToLoadFloorPlan": "Impossible de charger le plan de plancher",
  "couldNotUploadDiningImage": "Ne peut pas télécharger l'image de salle à manger",
  "diningImageSaved": "Image de dînage sauvegardée",
  "thePreviewIsTemporarilyUnavailableItWillAppearAutomaticallyWhenImageDeliveryRecovers": "L'aperçu est temporairement indisponible. Il apparaît automatiquement lorsque la livraison d'images se rétablit.",
  "unableToSaveArea": "Incapable de Enregistrer la zone",
  "chooseASupportedImage": "Choisissez une image prise en charge",
  "diningImageRemoved": "Image d'amortissement enlevée",
  "theChangeWasSavedButThePreviewServiceIsTemporarilyUnavailable": "Le changement a été enregistré, mais le service de prévisualisation est temporairement indisponible.",
  "unableToRemoveImage": "Impossible de supprimer l'image",
  "unableToDeactivateArea": "Incapable de désactiver la zone",
  "cancellationPolicySaved": "Politique d'annulation sauvegardée",
  "unableToSaveTable": "Incapable pour Enregistrer la table",
  "qRDownloadReady": "Téléchargement QR prêt",
  "yourPrivanaDiningQRFileHasBeenGenerated": "Votre fichier QR de Privana a été généré.",
  "unableToGenerateQR": "Incapable de générer des QR",
  "unableToLoadQRPreview": "Impossible de charger la prévisualisation QR",
  "thePublicQRURLHasBeenCopied": "L'URL publique QR a été copié.",
  "unableToDeactivateTable": "Impossible de désactiver la table",
  "unableToBulkAddTables": "Incapable d'ajouter des tableaux en vrac",
  "floorPlanSaved": "Plan d'étage enregistré",
  "yourLayoutChairsWallsAndDoorsWereSaved": "Votre disposition, vos chaises, vos murs et vos portes ont été sauvegardés.",
  "unableToSaveFloorPlan": "Incapable pour économiser le plan de plancher",
  "openHostConsoleInANewTab": "Ouvrir la console hôte dans un nouvel onglet",
  "openHostConsole": "Ouvrez Host Console",
  "addArea": "Ajouter la zone",
  "diningAreas": "Zones de restauration",
  "manageSharedRoomSectionsIndependentlyFromPOSOutletAssignments": "Gérer les sections de la salle partagée indépendamment des cessions de sortie de POS.",
  "loadingDiningAreas": "Chargement des zones à manger...",
  "noDiningAreasYetCreateYourFirstAreaToBegin": "Pas encore de salle à manger. Créez votre premier espace pour commencer.",
  "sharedDiningServiceSpace": "Espace de service partagé",
  "active": "Actif",
  "inactive": "Inactif",
  "unableToUpdateArea": "Impossible de mettre à jour la zone",
  "generateAreaQR": "Générer la zone QR",
  "cancellationPolicy": "Politique d ' annulation",
  "edit": "Modifier",
  "deactivate": "Désactiver",
  "tables": "Tableaux",
  "buildATableListForTheSelectedDiningArea": "Construisez une liste de table pour la salle à manger choisie.",
  "diningArea": "Zone d ' essai",
  "selectArea": "Sélectionnez la zone",
  "generateTableQRs": "Générer les RQ de table",
  "bulkAdd": "En vrac ajouter",
  "addTable": "Ajouter la table",
  "loadingTables": "Chargement des tables...",
  "selectADiningAreaToViewTables": "Sélectionnez une salle à manger pour voir les tables.",
  "thisArea": "cette zone",
  "table": "Tableau",
  "capacity": "Capacité :",
  "unableToUpdateTable": "Impossible de mettre à jour la table",
  "editDiningArea": "Éditer la zone de partage",
  "addDiningArea": "Ajouter la zone de restauration",
  "areaName": "Nom de la zone",
  "restaurant": "Restaurant",
  "activeArea": "Zone active",
  "enableOrDisableThisDiningArea": "Activer ou désactiver cette salle à manger.",
  "diningImage": "Image de dînage",
  "forBestResultsUseALandscapeImageAtLeast1600900pxJPEGPNGOrWebPUpTo5MB": "Pour de meilleurs résultats, utilisez une image de paysage au moins 1600 × 900px. JPEG, PNG ou WebP, jusqu'à 5 MB.",
  "diningAreaPreview": "Aperçu de la zone de restauration",
  "previewUnavailableYourImageIsStillSaved": "Aperçu indisponible — votre image est toujours sauvegardée",
  "addAWelcomingDiningHero": "Ajouter un héros de salle à manger accueillant",
  "replaceImage": "Remplacer l'image",
  "uploadImage": "Télécharger l ' image",
  "removeImage": "Supprimer l'image",
  "altTextOptional": "Texte alt (facultatif)",
  "candlelitTerraceOverlookingTheGarden": "Terrasse clôturée donnant sur le jardin",
  "horizontalFocus": "Cible horizontale",
  "verticalFocus": "Orientation verticale",
  "securelySavingDiningArea": "Une salle à manger sécurisée...",
  "cancel": "Annuler",
  "saving": "Enregistrement…",
  "saveArea": "Zone d ' essai",
  "thisDiningArea": "cette salle à manger",
  "minimumNoticeHoursBeforeReservationStart": "Heures de préavis minimum avant le début de la réservation",
  "removeDiningImage": "Enlever l'image ?",
  "membersWillSeeYourClubHeroOrPrivanaSDiningFallbackInsteadThisCannotBeUndone": "Les membres verront à la place votre héros de club ou la chute de repas de Privana. Cela ne peut pas être annulé.",
  "keepImage": "Gardez l'image",
  "removing": "Enlever...",
  "editTable": "Modifier la table",
  "addTableLabel": "Ajouter le tableau",
  "label": "Étiquette",
  "table12": "Tableau 12",
  "capacityLabel": "Capacité",
  "activeTable": "Table active",
  "deactivateToHideThisTableOnPOS": "Désactivez-vous pour cacher cette table sur POS.",
  "saveTable": "Sauvegarder la table",
  "bulkAddTables": "Tables d ' ajout en vrac",
  "startNumber": "Numéro de début",
  "endNumber": "Numéro de fin",
  "prefixOptional": "Préfixe (facultatif)",
  "capacityOptional": "Capacité (facultatif)",
  "createTables": "Créer des tables",
  "fileType": "Type de fichier",
  "previewQRCode": "Prévisualisation du code QR",
  "previewTableQRCodes": "Table de prévisualisation Codes QR",
  "loadingQRPreview": "Chargement de la prévisualisation QR...",
  "areaQRPreview": "Aperçu de la zone QR",
  "openLink": "Lien ouvert",
  "copyURL": "Copier l'URL",
  "open": "Ouvrir",
  "copy": "Bien reçu",
  "generating": "Generating...",
  "generateDownload": "Générer / Télécharger",
  "checkIn": "Vérifiez",
  "seat": "Siège",
  "complete": "Complet",
  "confirm": "Confirmer",
  "staff": "Personnel",
  "membersPortal": "Portail des Membres",
  "membersApp": "Membres Applicent",
  "guest": "Invité",
  "walkIn": "Marche-in",
  "accessDenied": "Accès refusé.",
  "unableToLoadDiningReservations": "Incapable de charger des réservations à manger.",
  "today": "Aujourd’hui",
  "tomorrow": "Demain",
  "future": "Avenir",
  "functions": "Fonctions",
  "createReservation": "Créer une réservation",
  "addWalkIn": "Ajouter Walk-In",
  "viewPastBookings": "Voir Réservations passées",
  "manageTableBlocks": "Gérer les blocs de tables",
  "retry": "Réessayer",
  "dismiss": "Rompez.",
  "notesOrAllergyInformation": "Notes ou renseignements sur les allergies",
  "noReservations": "Pas de réserves",
  "reservation": "Réservation",
  "date": "Date",
  "time": "Heure",
  "partySize": "Taille de la Partie",
  "duration": "Durée",
  "memberNotes": "Notes des membres",
  "staffNotes": "Notes du personnel",
  "reasonForCancelNoShow": "Motif d’annulation / d’absence",
  "saveChanges": "Enregistrer les modifications",
  "reject": "Rejet",
  "noShow": "Absent",
  "reservationType": "Type de réservation",
  "existingMember": "Membre existant",
  "memberSearch": "Recherche de membre",
  "searchMember": "Membre de la recherche",
  "guestName": "Nom de l'invité",
  "email": "E-mail",
  "phone": "Téléphone",
  "tableOptional": "Tableau (facultatif)",
  "createReservationLabel": "Créer une réservation",
  "pastBookings": "Réservations passées",
  "memberGuestOrReference": "Membre, invité ou référence",
  "allStatuses": "Tous les statuts",
  "allAreas": "Toutes les zones",
  "search": "Rechercher",
  "previous": "Précédent",
  "of": "des",
  "next": "Suivant",
  "reason": "Raison",
  "saveBlock": "Enregistrer le bloc",
  "addBlock": "Ajouter un bloc",
  "delete": "Supprimer",
  "deleteTableBlock": "Supprimer le bloc de table ?",
  "thisWillReturnTheTableToAvailabilityForTheBlockedPeriod": "Cela retournera le tableau à la disponibilité pour la période bloquée.",
  "keepBlock": "Continuez à bloquer",
  "deleteBlock": "Supprimer le bloc",
  "autoAssign": "Affecter automatiquement",
  "sunday": "Dimanche",
  "monday": "Lundi",
  "tuesday": "Mardi",
  "wednesday": "Mercredi",
  "thursday": "Jeudi",
  "friday": "Vendredi",
  "saturday": "Samedi",
  "addAtLeastOneServiceWindow": "Ajouter au moins une fenêtre de service.",
  "minimumPartySizeCannotExceedMaximumPartySize": "La taille minimale de la partie ne peut pas dépasser la taille maximale de la partie.",
  "reservations": "Réservations",
  "configureMemberAndGuestBookingAvailability": "Configurer les disponibilités des membres et des clients.",
  "reservationDays": "Jours de réservation",
  "serviceWindows": "Fenêtres de service",
  "addWindow": "Ajouter une fenêtre",
  "windowStart": "Démarrage de la fenêtre",
  "windowEnd": "Fenêtre",
  "removeServiceWindow": "Supprimer la fenêtre de service",
  "bookingIntervalMinutes": "Intervalle de réservation (minutes)",
  "defaultDurationMinutes": "Durée par défaut (minutes)",
  "minimumPartySize": "Taille minimale de la partie",
  "maximumPartySize": "Taille maximale de la partie",
  "maximumDaysAhead": "Jours maximums à venir",
  "minimumNoticeMinutes": "Avis minimum (minutes)",
  "cancellationWindowMinutes": "Fenêtre d'annulation (minutes)",
  "requireStaffApproval": "Demande d ' approbation du personnel",
  "allowGuestReservations": "Autoriser les réservations d'invité",
  "allowWalkIns": "Permettre des marches-ins",
  "small": "Petit",
  "medium": "Moyen",
  "large": "Grande",
  "general": "Généralités",
  "mainDining": "Restaurant principal",
  "windowSeating": "Fenêtre assise",
  "privateDining": "Salle à manger privée",
  "bar": "Bar",
  "patio": "Patio",
  "terrace": "Terrasse",
  "event": "Événement",
  "lounge": "Salon",
  "quietArea": "Secteur calme",
  "familyArea": "Zone familiale",
  "highTop": "Haut de page",
  "staffOnly": "Personnel seulement",
  "custom": "Personnalisé",
  "round2": "Ronde 2",
  "roundTables": "Tables rondes",
  "round4": "Ronde 4",
  "round6": "6e tour",
  "round8": "Ronde 8",
  "square2": "Carré 2",
  "squareTables": "Tables carrées",
  "square4": "Place 4",
  "rectangle4": "Rectangle 4",
  "rectangleTables": "Tables rectangulaires",
  "rectangle6": "Rectangle 6",
  "rectangle8": "Rectangle 8",
  "rectangle10": "Rectangle 10",
  "ovalBanquet": "Ovale / banquet",
  "specialSeating": "Sièges spéciaux",
  "booth": "Stand",
  "barCounter": "Bar / compteur",
  "serviceStation": "Station de services",
  "operations": "Opérations",
  "diningZone": "Zone d ' essai",
  "object": "Objet",
  "wallPath": "Chemin de fer",
  "door": "Porte",
  "floorPlanImage": "Plan du sol image",
  "selectionHandle": "Poignée de sélection",
  "dining": "Salle à manger",
  "floorPlanBuilder": "Plan d'étage constructeur",
  "dragTablesDrawWallsToggleIndividualChairsAndSaveAClubScopedLayout": "Faites glisser des tables, dessinez des murs, débranchez des chaises individuelles et sauvez une mise en page de la pochette.",
  "selectDiningArea": "Sélectionnez la salle à manger",
  "selectAnArea": "Sélectionnez une zone",
  "reload": "Recharge",
  "save": "Enregistrer",
  "duplicateTableLinksWereRepairedReviewUnlinkedTablesBeforeSaving": "Les liens de table double ont été réparés. Réviser les tables non reliées avant d'enregistrer.",
  "chooseADiningAreaToStart": "Choisissez une salle à manger pour commencer",
  "theBuilderWillKeepEachLayoutScopedToTheCurrentClubAndSelectedArea": "Le constructeur conservera chaque mise en page étendue au club actuel et à la zone sélectionnée.",
  "palette": "Palette",
  "clickOrDragOntoTheCanvas": "Cliquez ou faites glisser sur la toile.",
  "select": "Sélectionner",
  "wall": "Mur",
  "zone": "Zone",
  "ops": "Ops",
  "clickMoreWallPointsDoubleClickToFinishOrClickTheFirstPointToClose": "Cliquez sur d'autres points de mur. Double-cliquez pour terminer, ou cliquez sur le premier point pour fermer.",
  "clickTheWallStartPoint": "Cliquez sur le point de départ du mur.",
  "clickMoreZonePointsDoubleClickToFinishOrClickTheFirstPointToClose": "Cliquez sur d'autres points de zone. Double-cliquez pour terminer, ou cliquez sur le premier point pour fermer.",
  "clickTheFirstZonePoint": "Cliquez sur le premier point de zone.",
  "dragToMoveItemsShiftClickToSelectMultiple": "Faites glisser pour déplacer des éléments. Cliquez sur Maj pour sélectionner plusieurs.",
  "canvasSize": "Taille de la toile",
  "tracingMode": "Mode de traçage",
  "showZones": "Zones de spectacle",
  "zoneLegend": "Zone légende",
  "legend": "Légende",
  "keyboardShortcuts": "Shortcuts clavier",
  "wallTool": "Outil mural",
  "zoneTool": "Outil de zone",
  "selectOrCancel": "Sélectionnez ou annulez",
  "deleteSelected": "Supprimer sélectionné",
  "duplicate": "Duplicata",
  "undo": "Impasse",
  "redo": "Rétablir",
  "rotate15": "Tourner 15°",
  "arrows": "Flèches",
  "nudgeShift5x": "Déplacer légèrement (Maj = 5x)",
  "deleteObjects": "Supprimer les objets",
  "exitFullScreen": "Exit plein écran",
  "fullScreen": "Plein écran",
  "loadingFloorPlan": "Chargement du plan de sol...",
  "uploadAFloorPlanImageAlignItLockItThenTraceWallsOverTheTop": "Chargez une image de plan de sol, alignez-la, verrouillez-la, puis tracez les murs sur le dessus.",
  "hideTracingMode": "Cacher le mode de traçage",
  "unlockImage": "Débloquer image",
  "lockImage": "Image de verrouillage",
  "showBackgroundImage": "Afficher l'image de fond",
  "opacity": "Opacité",
  "tracingImageOpacity": "Traçage de l'opacité de l'image",
  "rotation": "Rotation",
  "tracingImageRotation": "Traçage de la rotation de l'image",
  "width": "Largeur",
  "tracingImageWidth": "Largeur de l'image",
  "height": "Hauteur",
  "tracingImageHeight": "Traçage de la hauteur d'image",
  "rotateLeft": "Tourner à gauche",
  "rotateRight": "Tournez à droite",
  "fitImageToCanvas": "Image adaptée à la toile",
  "clearImage": "Image dégagée",
  "pNGJPGJPEGAndWebPFilesAreSavedLocallyInTheFloorPlanLayoutJSONForNow": "Les fichiers PNG, JPG, JPEG et WebP sont sauvegardés localement dans le plan de sol JSON pour l'instant.",
  "startWithAPolishedEmptyPlan": "Commencez par un plan vide poli",
  "addATableFromThePaletteDrawAWallOrDropInADoorEverythingSnapsToTheGrid": "Ajouter une table de la palette, dessiner un mur, ou déposer une porte. Tout s'enfonce sur la grille.",
  "seats": "sièges",
  "pressEscToExitFullScreen": "Appuyez sur Esc pour quitter l'écran complet",
  "rotateHandle": "Poignée rotative",
  "service": "Service",
  "inspector": "Inspecteur",
  "multipleSelected": "Plusieurs sélections",
  "selectAnItemToEditDetails": "Sélectionnez un élément pour modifier les détails.",
  "useTheLeftPaletteToAddWallsDoorsTablesBoothsBarsAndServiceStations": "Utilisez la palette gauche pour ajouter des murs, des portes, des tables, des cabines, des barres et des stations de service.",
  "chairsAreChildrenOfTableTemplatesClickAChairOnTheCanvasToDisableOrEnableThatSeat": "Les chaises sont des enfants de modèles de table. Cliquez sur une chaise sur la toile pour désactiver ou activer ce siège.",
  "doorOpening": "Porte / ouverture",
  "tableObject": "Objet de la table",
  "nameLabel": "Nom / étiquette",
  "zoneType": "Type de zone",
  "zoneTypeLabel": "Type de zone",
  "color": "Couleur",
  "zoneColor": "Couleur de zone",
  "zoneColorValue": "Valeur de la couleur de zone",
  "zoneCapacity": "Capacité de zone",
  "activeTableSeats": "Sièges de table actifs",
  "tablesInZone": "Tableaux en zone",
  "activeTables": "Tables actives",
  "totalSeats": "Nombre total de sièges",
  "includesInactiveTables": "Comprend des tableaux inactifs",
  "layerPosition": "Position de la couche",
  "layer": "Couche",
  "showZone": "Zone de démonstration",
  "hiddenZonesAreNotShownButCanStillAssignReport": "Les zones cachées ne sont pas montrées mais peuvent encore attribuer/déclarer.",
  "bringForward": "Avance",
  "sendBackward": "Reculez.",
  "bringToFront": "Amenez-vous devant.",
  "sendToBack": "Envoyer à l'arrière",
  "cloneZone": "Zone de fermeture",
  "tableNumber": "Numéro de tableau",
  "linkedDiningTable": "Table à manger reliée",
  "createOrLinkTable": "Création ou table de lien",
  "createNewOnSave": "Créer un nouveau sur l'épargne",
  "linkedDiningTableLabel": "Table à manger reliée",
  "sourceOfTruth": "Source de vérité:",
  "noArea": "Pas de zone",
  "outlet": "Sortie",
  "noOutlet": "Pas de sortie",
  "capacityComesFromTheLinkedDiningTableSourceOfTruth": "La capacité vient de la table à manger liée source de vérité.",
  "capacityIsControlledByEnabledChairObjects": "La capacité est contrôlée par des objets de chaise activés.",
  "points": "Points",
  "edges": "Bords",
  "segments": "Débats",
  "inactiveZonesDoNotAssignReport": "Les zones inactives n'attribuent pas/déclarent.",
  "inactiveObjectsAreFadedOnThePlan": "Les objets inactifs sont évanouis sur le plan.",
  "deleteZone": "Supprimer la zone",
  "deleteItem": "Supprimer le point",
  "diningHostConsole": "Console hébergée à manger",
  "thePublishedFloorCouldNotBeDisplayed": "L'étage publié n'a pas pu être affiché.",
  "reservationsAndServiceDataAreStillAvailable": "Les réservations et les données de service sont toujours disponibles.",
  "refreshingFloor": "A l'étage...",
  "retryFloor": "Rez-de-chaussée",
  "publishedDiningFloorPlan": "Plan d ' aménagement pour les repas",
  "interactiveDiningFloorDragToMoveUseTheMouseWheelOrPinchGestureToZoom": "Planche à manger interactive. Faites glisser pour déplacer. Utilisez la roue de la souris ou le geste de la pincée pour zoomer.",
  "zoomOut": "Zoom.",
  "fitFloor": "Rez-de-chaussée",
  "zoomIn": "Zoom avant",
  "guestParty": "Invité fête",
  "authenticatedStaff": "Personnel authentifié",
  "floor": "Étage",
  "unableToPrepareDiningOperations": "Incapable de préparer les opérations de Dining.",
  "unableToRefreshDiningOperations": "Incapable de rafraîchir les opérations de Dining.",
  "thisReservationChangedOnAnotherDeviceTheLatestDetailsHaveBeenLoaded": "Cette réservation a changé sur un autre appareil. Les derniers détails ont été chargés.",
  "actionFailed": "L'action a échoué.",
  "waitlist": "Liste d’attente",
  "arrived": "Arrivé",
  "seated": "Assise",
  "available": "Disponible",
  "late": "En retard",
  "noShows": "Pas de spectacles",
  "weCouldnTLogYouOutPleaseTryAgain": "Nous ne pouvions pas vous déconnecter.",
  "noDiningAreasConfigured": "Pas de salle à manger configurée",
  "covers": "couvre les couvertures",
  "signOut": "Signez.",
  "hostConsole": "Console héberge",
  "todaySOperationalSummary": "Résumé opérationnel d’aujourd’hui",
  "preparingTodaySFloorAndReservations": "Préparer le plancher et les réservations d’aujourd’hui...",
  "liveFloor": "Sol en direct",
  "refreshing": "Rafraîchissement",
  "noActiveDiningAreasAreConfigured": "Pas d'espaces d'affinage actifs sont configurés",
  "noActiveDiningTablesAreConfigured": "Aucune table à manger active n'est configurée",
  "noPublishedFloorPlanIsAvailableForThisArea": "Aucun plan d'étage publié n'est disponible pour ce secteur",
  "markThisReservationAsNoShow": "Marquer cette réservation comme non honorée ?",
  "completeThisDiningVisit": "Compléter cette visite à manger ?",
  "comingNextThisPhaseKeepsFocusOnLiveFloorAndReservationOperations": "J'arrive. Cette phase se concentre sur les opérations de sol et de réservation en direct.",
  "servicePulse": "Pulse de service",
  "noReservationsForToday": "Pas de réservation pour aujourd'hui",
  "activeReservations": "Réserves actives",
  "unassigned": "Non attribué",
  "noReservationsForThisDate": "Pas de réservation pour cette date",
  "next45Days": "45 jours suivant",
  "futureReservations": "Réserves futures",
  "noFutureReservations": "Aucune réserve future",
  "markArrived": "Mark est arrivé.",
  "runningLate": "Courage tard",
  "assignTable": "Tableau d ' affectation",
  "noShowLabel": "Absence",
  "seatParty": "Du siège",
  "seatAssignTable": "Siège / table d ' assignation",
  "changeTable": "Table de changement",
  "completeVisit": "Visite complète",
  "close": "Fermer",
  "member": "Membre",
  "status": {
    "pending": "pendant l ' attente",
    "confirmed": "confirmé",
    "checked_in": "vérifiée",
    "seated": "assis",
    "completed": "achevé",
    "cancelled": "annulé",
    "no_show": "absence",
    "available": "disponible",
    "assigned": "c)",
    "reserved_soon": "réservé bientôt",
    "arrived": "arrivés",
    "blocked": "bloqués",
    "inactive": "inactif"
  },
  "party": "Partie",
  "notesAllergyIndicators": "Notes/indicateurs d'allergie",
  "viewOnlyDiningBookingsAccess": "View-only Dining Accès aux réservations",
  "upcomingAssigned": "À venir / assigné",
  "noUpcomingReservationsAssignedToThisTable": "Pas de réservations à venir assignées à ce tableau.",
  "invalidClubRoute": "Itinéraire du club invalide",
  "useACanonicalSixDigitClubCode": "Utilisez un code club canonique à six chiffres.",
  "accessDeniedLabel": "Accès refusé",
  "unableToLoadHostConsole": "Incapable de charger la console hôte",
  "privanaCouldNotCompleteClubResolutionOrAuthorisationPleaseRetry": "Privana ne pouvait pas compléter la résolution ou l'autorisation du club. S'il vous plaît retry.",
  "signingYouOut": "Je t'ai signé...",
  "enterAClubRoute": "Entrez un parcours de club",
  "open123001ToStartDiningHostConsole": "Ouvrez /123001 pour commencer la console d'accueil.",
  "deactivateArea": "Désactiver {name} ?",
  "deactivateTable": "Désactiver la table {label} ?",
  "cancellationDescription": "Configurer l'annulation des membres pour {name} .",
  "noTablesForArea": "Pas encore de tables. Ajouter des tables pour {name} .",
  "areaQrSummary": "Génération d'une zone QR pour {name} .",
  "tableQrSummary": "Tableau de Génération QRs pour {name} ( {count} tables actives).",
  "tableQrSummaryOne": "Tableau de Génération QRs pour {name} ( {count} tables actives).",
  "qrPreview": "{label} Aperçu QR",
  "urlCopied": "URL copié",
  "reservationReference": "Réserve {reference}",
  "areaTable": "{area} · Tableau {table}",
  "tableLabel": "Tableau {label}",
  "pagination": "{from} – {to} de {total}",
  "validWindow": "Entrez un temps de début et de fin valide pour {day} .",
  "overlappingWindows": "{day} fenêtres de service ne peuvent pas se chevaucher.",
  "selectedObjects": "{count} objets sélectionnés. Faites glisser tout objet sélectionné pour déplacer le groupe, ou utilisez des raccourcis clavier pour dupliquer, supprimer et nudge.",
  "linkedTableSummary": "Source de vérité: {label} · {capacity} sièges · {status} .",
  "resizeHandle": "Redimensionner {handle}",
  "zonePointHandle": "Zone point {number} anse",
  "wallPointHandle": "Portefeuille {number}",
  "tableState": "Tableau {label} , {status}",
  "signOutStaff": "Signer {name}",
  "coverCountOne": "Couverts : {count}",
  "coverCountOther": "Couverts : {count}",
  "activeCount": "Actifs : {count}",
  "publishedLayout": "Mise en page publiée · {name}",
  "serviceSummary": "{waiting} attente · {seated} assis · {available} tables disponibles · {completed} complétées.",
  "lateStatus": "{status} · fin",
  "dateReservations": "Réservations : {date}",
  "upcomingSummary": "{time} · {count} invités · {status}",
  "unauthorisedClub": "Votre compte n'est pas autorisé pour l'accès Dining Host Console au club {clubCode} .",
  "selectDate": "Sélectionnez la date",
  "chooseServiceDate": "Choisissez la date de service",
  "serviceDate": "Date du service",
  "unknownStatus": "Statut inconnu",
  "unknownSource": "Source inconnue",
  "genericError": "Impossible de remplir la demande de repas. Veuillez réessayer.",
  "requestReference": "{message} (Numéro de demande: {requestId} )",
  "authRestoring": "Restaurer... session",
  "authAuthenticating": "authentification",
  "authResolving": "résoudre... le club",
  "authAuthorising": "autorisant",
  "authLoading": "chargement",
  "topLeft": "haut à gauche",
  "topRight": "haut à droite",
  "bottomLeft": "en bas gauche",
  "bottomRight": "en bas droit",
  "source": {
    "staff": "Personnel",
    "member_portal": "Portail des Membres",
    "members_mobile": "Membres Applicent",
    "guest": "Invité",
    "walk_in": "Marche-in"
  },
  "errors": {
    "slot_unavailable": "La table ou l'heure sélectionnée n'est plus disponible.",
    "party_size_out_of_range": "La taille de la partie est à l'extérieur de la plage autorisée.",
    "invalid_party_size": "Entrez une taille de fête valide.",
    "invalid_guest_name": "Entrez un nom d'invité.",
    "invalid_guest_email": "Entrez une adresse email valide.",
    "invalid_guest_phone": "Entrez un numéro de téléphone valide.",
    "invalid_member_id": "Sélectionnez un membre valide.",
    "member_not_found": "Le membre n'a pas pu être trouvé.",
    "area_not_found": "La salle à manger n'a pas pu être trouvée.",
    "table_not_found": "On n'a pas trouvé la table.",
    "reservation_not_found": "La réservation n'a pas pu être trouvée.",
    "reservation_terminal": "Cette réservation ne peut plus être changée.",
    "invalid_status_transition": "Ce changement de statut n'est pas permis.",
    "reason_required": "Saisissez une raison pour cette action.",
    "invalid_local_datetime": "Entrez une date et une heure de réservation valides.",
    "invalid_local_time": "Cette heure locale n'est pas valable dans le fuseau horaire du club.",
    "ambiguous_local_time": "Cette fois se produit deux fois lorsque les horloges changent. Choisissez une autre fois.",
    "invalid_duration": "Entrez une durée valide.",
    "duration_not_permitted": "Cette durée n'est pas permise.",
    "minimum_notice_not_met": "L'avis de réservation minimum n'a pas été respecté.",
    "outside_service_window": "La réservation est à l'extérieur des fenêtres de service.",
    "booking_interval_mismatch": "Choisissez un temps qui correspond à l'intervalle de réservation.",
    "reservation_day_unavailable": "Les réservations ne sont pas disponibles ce jour de service.",
    "reservation_date_out_of_range": "La date de réservation est à l'extérieur de la plage autorisée.",
    "reservations_unavailable": "Les réservations ne sont pas disponibles pour cette salle à manger.",
    "walk_ins_disabled": "Les Walk-ins sont handicapés pour cette salle à manger.",
    "guest_reservations_disabled": "Les réservations sont désactivées pour cette salle à manger.",
    "table_block_conflicts_with_reservation": "Le bloc de table est en conflit avec une réserve.",
    "block_not_found": "Le bloc de table n'a pas pu être trouvé.",
    "invalid_table_block": "Entrez un bloc de table valide.",
    "invalid_date_filter": "Entrez un filtre de date valide.",
    "invalid_range": "Entrez une gamme de nombres valide.",
    "rate_limited": "Trop de demandes. S'il vous plaît essayez à nouveau bientôt.",
    "invalid_upload": "Sélectionnez une image pour télécharger.",
    "invalid_image_type": "Téléchargez une image JPEG, PNG ou WebP valide.",
    "malformed_image": "L'image est corrompue, tronquée ou ne peut être décodée.",
    "image_too_large": "Les images doivent être de 5 Mo ou moins.",
    "service_windows_required": "Ajouter au moins une fenêtre de service.",
    "overlapping_service_windows": "Les fenêtres de service ne peuvent pas se chevaucher.",
    "invalid_reservation_settings": "Vérifiez les paramètres de réservation.",
    "invalid_party_size_range": "La taille minimale de la partie ne peut pas dépasser la taille maximale de la partie.",
    "invalid_reservation_time_increment": "Les intervalles et les durées de réservation doivent utiliser des augmentations de cinq minutes.",
    "invalid_booking_interval": "Entrez un intervalle de réservation entre 5 et 240 minutes.",
    "invalid_default_duration": "Entrez une durée par défaut entre 15 et 720 minutes.",
    "invalid_minimum_party_size": "Entrez une taille minimale entre 1 et 100.",
    "invalid_maximum_party_size": "Entrez une taille maximale de la partie entre 1 et 500.",
    "invalid_maximum_days_ahead": "Entrez un horizon de réservation entre 0 et 730 jours.",
    "invalid_minimum_notice": "Entrez un préavis minimum entre 0 et 10080 minutes.",
    "invalid_cancellation_window": "Entrez une fenêtre d'annulation entre 0 et 43200 minutes.",
    "invalid_service_window_time": "Entrez une date de début et de fin de service valide.",
    "invalid_service_window_day": "Sélectionnez une journée de service valide.",
    "service_window_day_disabled": "Activez la journée de réservation avant d'ajouter une fenêtre de service.",
    "invalid_service_windows": "Vérifiez les fenêtres de service.",
    "invalid_service_window": "Vérifiez la fenêtre de service.",
    "invalid_reservation_days": "Sélectionnez les jours de réservation valides.",
    "unknown_reservation_setting": "Les réglages de réservation contiennent une option non supportée.",
    "invalid_area_id": "Sélectionnez une salle à manger valide.",
    "invalid_table_id": "Sélectionnez une table valide.",
    "table_not_in_area": "La table sélectionnée n'appartient pas à cette salle à manger.",
    "duplicate_linked_table": "Chaque table visuelle active peut se connecter à une table à manger une seule fois.",
    "linked_table_invalid": "La table à manger liée n'est pas valide.",
    "invalid_status": "Sélectionnez un statut de réservation valide.",
    "invalid_booking_source": "Sélectionnez une source de réservation valide.",
    "invalid_search": "Entrez une recherche valide.",
    "invalid_start_at": "Entrez une heure de début de réservation valide.",
    "invalid_reservation_id": "Sélectionnez une réservation valide.",
    "floor_plan_not_found": "Le plan d'étage n'a pas été trouvé.",
    "invalid_floor_plan_id": "Sélectionnez un plan d'étage valide."
  },
  "vip": "VIP",
  "reservationCount": "Réservations : {count}",
  "logoutTitle": "Se déconnecter de Privana ?",
  "logoutDescription": "Tu es sûr de vouloir te déconnecter ?",
  "loggingOut": "Se déconnecter...",
  "logOut": "Déconnexion.",
  "print": {
    "heading": "RESTAURATION PRIVANA",
    "instruction": "Scanner pour afficher le menu",
    "area": "Zone de restauration QR",
    "table": "Tableau QR"
  },
  "reminder": {
    "title": "Rappel de la réservation",
    "body": "Votre réservation à manger {reference} arrive."
  },
  "seatCount": "Places : {count}",
  "partyStatus": "Invités : {count} · {status}",
  "guestCount": "Invités : {count}",
  "saved": "Changements enregistrés.",
  "activeCountOne": "Actifs : {count}",
  "reservationCountOne": "Réservations : {count}",
  "seatCountOne": "Places : {count}",
  "guestCountOne": "Invités : {count}",
  "partyStatusOne": "Invités : {count} · {status}",
  "linkedTableSummaryOne": "Source de vérité: {label} · {capacity} sièges · {status} .",
  "statusLabel": "Statut",
  "layerSummary": "Calque {position} de {total}",
  "elapsedMinutes": "{count} m",
  "resizeCorner": {
    "nw": "nw",
    "ne": "ne",
    "se": "se branle",
    "sw": "sw"
  },
  "missingPolicyHandler": "Impossible d'enregistrer la politique d'annulation. Save handler n'est pas configuré."
};
